module.exports = __webpack_public_path__ + "assets/img/tdhelp.37d5fd04.png";